import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "src/_services/app.service";
import { FormBuilder, FormGroup } from "@angular/forms";

@Component({
    selector: "app-arbitrage-configuration",
    templateUrl: "./arbitrage-configuration.component.html",
    styleUrls: ["./arbitrage-configuration.component.scss"],
})
export class ArbitrageConfigurationComponent implements OnInit {
    arbitrageForm: FormGroup;
    public userInfo: any = JSON.parse(sessionStorage.getItem("currentUser"));

    constructor(
        private formBuilder: FormBuilder,
        private appService: AppService,
        private router: Router
    ) { }

    ngOnInit() {
        this.arbitrageForm = this.formBuilder.group({
            service: this.formBuilder.group({
                arbitrageEnabled: [true, ""],
                marketbookEnabled: [true, ""],
            }),
            betfair: this.formBuilder.group({
                volumeThreshold: [0],
                conversionRate: [0],
                percentage: [0],
                retryCount: [0],
            }),
            sportradar: this.formBuilder.group({
                conversionRate: [0],
                percentage: [0],
            }),
            margin: this.formBuilder.group({
                arbitrageMarginThreshold: [0],
            }),
            ggr: this.formBuilder.group({
                minGgr: [0],
                maxGgr: [0],
                maxRiskPerMarket: [0],
            }),
            risk: this.formBuilder.group({
                noMarginTriggerRisk: [0],
            }),
            stake: this.formBuilder.group({
                min: [0],
                max: [0],
            }),
        });
        this.getArbitrageConfig();
    }

    get f() {
        return this.arbitrageForm.controls;
    }

    get service() {
        const serviceGroup = this.arbitrageForm.get("service") as FormGroup;
        return serviceGroup ? serviceGroup.controls : {};
    }

    get betfair() {
        const betfairGroup = this.arbitrageForm.get("betfair") as FormGroup;
        return betfairGroup ? betfairGroup.controls : {};
    }

    get sportradar() {
        const sportradarGroup = this.arbitrageForm.get("sportradar") as FormGroup;
        return sportradarGroup ? sportradarGroup.controls : {};
    }

    get margin() {
        const marginGroup = this.arbitrageForm.get("margin") as FormGroup;
        return marginGroup ? marginGroup.controls : {};
    }

    get ggr() {
        const ggrGroup = this.arbitrageForm.get("ggr") as FormGroup;
        return ggrGroup ? ggrGroup.controls : {};
    }

    get risk() {
        const riskGroup = this.arbitrageForm.get("risk") as FormGroup;
        return riskGroup ? riskGroup.controls : {};
    }

    get stake() {
        const stakeGroup = this.arbitrageForm.get("stake") as FormGroup;
        return stakeGroup ? stakeGroup.controls : {};
    }

    getArbitrageConfig() {
        try {
            this.appService.getArbitrageConfig().subscribe(
                (res) => {
                    if (res.status === "RS_OK") {
                        const config = res.config || {};
                        this.arbitrageForm.patchValue({
                            service: {
                                arbitrageEnabled: config.service && config.service.arbitrageEnabled !== undefined ? config.service.arbitrageEnabled : true,
                                marketbookEnabled: config.service && config.service.marketbookEnabled !== undefined ? config.service.marketbookEnabled : true,
                            },
                            betfair: {
                                volumeThreshold: config.betfair && config.betfair.volumeThreshold ? config.betfair.volumeThreshold : 0,
                                conversionRate: config.betfair && config.betfair.conversionRate ? config.betfair.conversionRate : 0,
                                percentage: config.betfair && config.betfair.percentage ? config.betfair.percentage : 0,
                                retryCount: config.betfair && config.betfair.retryCount ? config.betfair.retryCount : 0,
                            },
                            sportradar: {
                                conversionRate: config.sportradar && config.sportradar.conversionRate ? config.sportradar.conversionRate : 0,
                                percentage: config.sportradar && config.sportradar.percentage ? config.sportradar.percentage : 0,
                            },
                            margin: {
                                arbitrageMarginThreshold: config.margin && config.margin.arbitrageMarginThreshold ? config.margin.arbitrageMarginThreshold : 0,
                            },
                            ggr: {
                                minGgr: config.ggr && config.ggr.minGgr !== undefined ? config.ggr.minGgr : 0,
                                maxGgr: config.ggr && config.ggr.maxGgr ? config.ggr.maxGgr : 0,
                                maxRiskPerMarket: config.ggr && config.ggr.maxRiskPerMarket ? config.ggr.maxRiskPerMarket : 0,
                            },
                            risk: {
                                noMarginTriggerRisk:
                                    config.risk && config.risk.noMarginTriggerRisk !== undefined && config.risk.noMarginTriggerRisk !== null
                                        ? config.risk.noMarginTriggerRisk
                                        : 0,
                            },
                            stake: {
                                min: config.stake && config.stake.min !== undefined ? config.stake.min : 0,
                                max: config.stake && config.stake.max !== undefined ? config.stake.max : 0,
                            },
                        });
                    } else if (res.errorDescription === "Invalid Token!") {
                        this.appService.openErrorBar(res.errorDescription);
                        sessionStorage.clear();
                        this.router.navigateByUrl("/login");
                    } else {
                        this.appService.openErrorBar(res.errorDescription || "Failed to load arbitrage configuration");
                    }
                },
                (error) => {
                    console.log("error", error);
                }
            );
        } catch (err) { }
    }

    onSubmit() {
        const payload = {
            service: {
                arbitrageEnabled: this.service.arbitrageEnabled.value,
                marketbookEnabled: this.service.marketbookEnabled.value,
            },
            betfair: {
                volumeThreshold: this.betfair.volumeThreshold.value,
                conversionRate: this.betfair.conversionRate.value,
                percentage: this.betfair.percentage.value,
                retryCount: this.betfair.retryCount.value,
            },
            sportradar: {
                conversionRate: this.sportradar.conversionRate.value,
                percentage: this.sportradar.percentage.value,
            },
            margin: {
                arbitrageMarginThreshold: this.margin.arbitrageMarginThreshold.value,
            },
            ggr: {
                minGgr: this.ggr.minGgr.value,
                maxGgr: this.ggr.maxGgr.value,
                maxRiskPerMarket: this.ggr.maxRiskPerMarket.value,
            },
            risk: {
                noMarginTriggerRisk: this.risk.noMarginTriggerRisk.value,
            },
            stake: {
                min: this.stake.min.value,
                max: this.stake.max.value,
            },
        };

        try {
            this.appService.setArbitrageConfig(payload).subscribe(
                (res) => {
                    if (res.status === "RS_OK") {
                        this.appService.openSuccessBar(res.errorDescription || "Arbitrage configuration saved successfully");
                    } else {
                        this.appService.openErrorBar(res.errorDescription || "Failed to save arbitrage configuration");
                        if (res.errorDescription === "Invalid Token!") {
                            sessionStorage.clear();
                            this.router.navigateByUrl("/login");
                        }
                    }
                },
                (error) => {
                    console.log("error", error);
                }
            );
        } catch (err) { }
    }
}

